import script from "./langSwitcher.vue?vue&type=script&setup=true&lang=js"
export * from "./langSwitcher.vue?vue&type=script&setup=true&lang=js"

import "./langSwitcher.vue?vue&type=style&index=0&id=7a7df41e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a7df41e"]])

export default __exports__